import type { Ring } from '@/app/[locale]/product/_hooks/types';
import type { RingStyle } from '@/app/types/ring';
import type { ProductDiscountedPriceFragment } from '@/queries/fragments/ProductFragment';

// the lowest original price of all rings
export const getRingsOldOriginalBasePrice = (
  rings: Ring[] | undefined,
): Record<string, ProductDiscountedPriceFragment['originalPrice']> => {
  if (!rings) {
    return {};
  }
  return rings.reduce(
    (
      acc: Record<string, ProductDiscountedPriceFragment['originalPrice']>,
      cur: Ring,
    ) => {
      const style: RingStyle | undefined = cur.style;
      //TODO: GROW-1607 clean up This can be changed back to cur.discountedPrice.originalPrice after we run out of gen3 stock, the oldPrice field is used to support the gen3 ring discounts for gen4 launch
      const originalPrice = cur.oldPrice ?? cur.discountedPrice.originalPrice;
      if (style && originalPrice) {
        if (!acc[style]) {
          acc[style] = originalPrice;
        } else {
          const amount = acc[style].amount ?? 0;
          acc[style] = {
            ...originalPrice,
            amount: Math.min(amount, originalPrice.amount ?? 0),
          };
        }
      }
      return acc;
    },
    {},
  );
};
// the lowest original price of all rings
export const getRingsOriginalBasePrice = (
  rings: Ring[] | undefined,
): Record<string, ProductDiscountedPriceFragment['originalPrice']> => {
  if (!rings) {
    return {};
  }
  return rings.reduce(
    (
      acc: Record<string, ProductDiscountedPriceFragment['originalPrice']>,
      cur: Ring,
    ) => {
      const style: RingStyle | undefined = cur.style;
      //This can be changed back to cur.discountedPrice.originalPrice after we run out of gen3 stock, the oldPrice field is used to support the gen3 ring discounts for gen4 launch
      const originalPrice = cur.discountedPrice.originalPrice ?? 0;
      if (style && originalPrice) {
        if (!acc[style]) {
          acc[style] = originalPrice;
        } else {
          const amount = acc[style].amount ?? 0;
          acc[style] = {
            ...originalPrice,
            amount: Math.min(amount, originalPrice.amount ?? 0),
          };
        }
      }
      return acc;
    },
    {},
  );
};

// the lowest discount price of all rings
const getRingsDiscountBasePrice = (
  rings: Ring[] | undefined,
): Record<string, ProductDiscountedPriceFragment['discountedPrice']> => {
  if (!rings) {
    return {};
  }
  return rings.reduce(
    (
      acc: Record<string, ProductDiscountedPriceFragment['discountedPrice']>,
      cur: Ring,
    ) => {
      const style: RingStyle | undefined = cur.style;
      const { discountedPrice } = cur.discountedPrice;
      if (style && discountedPrice) {
        if (!acc[style]) {
          acc[style] = discountedPrice;
        } else {
          const amount = acc[style].amount ?? 0;
          acc[style] = {
            ...discountedPrice,
            amount: Math.min(amount, discountedPrice.amount ?? 0),
          };
        }
      }
      return acc;
    },
    {},
  );
};

export default getRingsDiscountBasePrice;
